<template>
  <div class="grid grid-cols-3 items-center text-dark-neutral-500 group w-full">
    <div class="">
      <PlanLockGuard>
        <TextInput
          v-model="internalEvaluator.role"
          placeholder="Author"
          input-classes="border-none"
          :disabled="review.isPlanReadonly.value"
          @enter="updateEvaluator"
          @blur="updateEvaluator"
        />
      </PlanLockGuard>
    </div>

    <div class="">
      <PlanLockGuard>
        <EvaluatorsCombobox
          v-model="internalEvaluator.name"
          input-classes="border-none w-full "
          :disabled="review.isPlanReadonly.value"
          @update:model-value="updateEvaluator"
        />
      </PlanLockGuard>
    </div>

    <div class="flex justify-end invisible group-hover:visible">
      <PlanLockGuard>
        <button
          class="text-red-600"
          :disabled="review.isPlanReadonly.value"
          @click="deleteEvaluator"
        >
          <TrashIcon class="size-5" />
        </button>
      </PlanLockGuard>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Evaluator } from '@core/domain/models/evaluator.model'
import { ReviewKey } from '../../use-review'
import { injectStrict } from '@app/utils/injectStrict'
import TextInput from '@app/components/Global/Inputs/TextInput.vue'
import { ref } from 'vue'
import useLoading from '@app/composables/use-loading'
import useSnackbar from '@app/composables/use-snackbar'
import EvaluatorsCombobox from './EvaluatorsCombobox.vue'
import TrashIcon from '@app/components/Icons/TrashIcon.vue'
import { deepEqual } from '@app/utils/objects'
import PlanLockGuard from '../PlanLockGuard.vue'

const props = defineProps<{
  evaluator: Evaluator
}>()

const loading = useLoading()
const snackbar = useSnackbar()
const internalEvaluator = ref({
  role: props.evaluator.role,
  name: props.evaluator.name,
  id: props.evaluator.id,
  order: props.evaluator.order,
})
const review = injectStrict(ReviewKey)

async function updateEvaluator() {
  if (deepEqual(internalEvaluator.value, props.evaluator)) {
    return
  }
  loading.start()
  try {
    await review.updateEvaluator(internalEvaluator.value)
    snackbar.success('Success')
  } catch (e) {
    snackbar.error('Failed to update evaluator')
    throw e
  } finally {
    loading.stop()
  }
}

async function deleteEvaluator() {
  loading.start()
  try {
    await review.deleteEvaluator(internalEvaluator.value.id)
    snackbar.success('Success')
  } catch (e) {
    snackbar.error('Failed to delete evaluator')
    throw e
  } finally {
    loading.stop()
  }
}
</script>
